/**
 * Contact forms on the clinic's website (owner request, 15 October 2026). The WordPress plugin
 * hooks the form plugins' "after submit" actions and posts each submission here, server to
 * server, with the clinic's connection key. A later generic webhook can reuse the same shape.
 */
import { z } from "zod";
/** "wpd.<clinicId>.<secret>": the clinic id lets the plugin also print the button snippet. */
export const CONNECTION_KEY_PATTERN = /^wpd\.([A-Za-z0-9_-]{1,64})\.([a-f0-9]{48})$/;
export const FORM_PLUGINS = [
    "gravityforms",
    "cf7",
    "wpforms",
    "elementor",
    "fluentforms",
    "divi",
    "ninjaforms",
    "formidable",
    "forminator",
    "everest",
    "jetpack",
    "kadence",
    "spectra",
    "beaver",
    "wsform",
    "metform",
    "jetformbuilder",
    "happyforms",
    "weforms",
    "otter",
    "sureforms",
    "other",
];
const fieldValueSchema = z.union([
    z.string().max(5000),
    z.array(z.string().max(500)).max(50),
    z.boolean(),
]);
export const inboundFieldSchema = z.object({
    id: z.string().min(1).max(64),
    label: z.string().max(200).default(""),
    /** The form plugin's own field type: email, phone, name, select, textarea, consent, … */
    type: z.string().max(40).default("text"),
    value: fieldValueSchema,
});
export const inboundFormRequestSchema = z.object({
    /** The site's home URL; it must be one of the clinic's licensed websites. */
    site: z.string().min(3).max(2048),
    /** The page the form was sent from, when the form plugin knows it. */
    pageUrl: z.string().max(2048).optional(),
    plugin: z.enum(FORM_PLUGINS),
    form: z.object({ id: z.string().min(1).max(64), title: z.string().max(120).default("") }),
    /** The form plugin's entry id or a random id; makes retries idempotent. */
    submissionId: z.string().min(1).max(128),
    fields: z.array(inboundFieldSchema).min(1).max(80),
    pluginVersion: z.string().max(20).optional(),
});
/** The plugin's "Test connection" and its report of the forms it found (titles only, no data). */
export const inboundPingRequestSchema = z.object({
    site: z.string().min(3).max(2048),
    pluginVersion: z.string().max(20).optional(),
    forms: z
        .array(z.object({
        plugin: z.enum(FORM_PLUGINS),
        id: z.string().min(1).max(64),
        title: z.string().max(120).default(""),
        enabled: z.boolean(),
        hasConsent: z.boolean().optional(),
    }))
        .max(100)
        .optional(),
});
//# sourceMappingURL=inbound.js.map